
export default function Headers() {
     return(
          <header className = "header-name">
          <h1 className = "title">
               Alive Gardens
          </h1>
          <p className = "welcome-text">
               
          </p>

          </header>

     );
}